module.exports = __webpack_public_path__ + "img/Asset4.e52d8261.png";